import React from "react";
import styles from "./stylesheets/footer.module.css";
import { Link } from "react-router-dom";


const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.mainDiv}>
        <div className={styles.companyContainer}>
          <img src="/images/drunken-bytes-logo-complete.png" alt="LOGO" />
          <p>
            Drunken Bytes is an innovative NFT platform providing businesses with 
            a simple way to create and manage product and credential NFTs.
          </p>
        </div>
        <div className={styles.containersContainer}>
          <div className={styles.container}>
            <p>Company</p>
            <Link to="/about" className={styles.containerLinks}>
              About
            </Link>
            <Link to="/careers" className={styles.containerLinks}>
              Careers
            </Link>
          </div>
          <div className={styles.container}>
            <p>Product</p>
            <Link to="/pricing" className={styles.containerLinks}>
              Pricing
            </Link>
            <Link to="/why-choose-us" className={styles.containerLinks}>
              Why Choose Us?
            </Link>
          </div>
          <div className={styles.container}>
            <p>Docs & Help</p>
            <Link to="/documentation" className={styles.containerLinks}>
              Documentation
            </Link>
            <Link to="/blogs" className={styles.containerLinks}>
              Blogs
            </Link>
            <Link to="/help-center" className={styles.containerLinks}>
              Help Center
            </Link>
            <Link to="/faq" className={styles.containerLinks}>
              FAQ
            </Link>
          </div>
          <div className={styles.container}>
            <p>Get in Touch</p>
            <Link to="/contact-us" className={styles.containerLinks}>
              Contact Us
            </Link>
            <Link to="/raise-issue" className={styles.containerLinks}>
              Raise Issue
            </Link>
          </div>
        </div>
      </div>
      <div className={styles.copyrightDiv}>
        <p className={styles.copyright}>
          © {new Date().getFullYear()} Drunken Bytes. All Rights Reserved.
        </p>
        <div className={styles.policyAndTerms}>
          <Link to="/privacy-policy" className={styles.policyAndTermsLinks}>
            Privacy Policy
          </Link>
          <Link to="/terms-of-service" className={styles.policyAndTermsLinks}>
            Terms of Service
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;